module.exports = __webpack_public_path__ + "static/img/camo_max.48801bfe.png";